module.exports = __webpack_public_path__ + "img/9f.03f50cfd.png";